// 控制轮播页面的轮播
export default class SwiperController {
  refsDomList = [];
  $myrefs = null;
  scrollTimer = null;
  resizeTimer = null;
  scrollHandler = null;
  resizeHandler = null;
  currentAutoPlaySwiper = null;

  swiperStart(refsDomList, $refs) {
    this.refsDomList = refsDomList;
    this.$myrefs = $refs;
    this.swiperDestroy();
    this.run();
  }

  run() {
    // 初始化执行
    setTimeout(() => {
      // todo 在mounted中直接执行updateDomPointYs时，元素还没有加载完，获取到的offsetTop值不够准确，需要异步获取下
      this.updateDomPointYs(); // 延迟更新主要是为了延迟执行这个函数
      this.updateCarouselSwiper();
    }, 200);
    /// 设置监听事件
    // 监听滚动事件
    window.addEventListener(
      "scroll",
      (this.scrollHandler = () => {
        // 节流
        if (this.scrollTimer) {
          return;
        }
        this.scrollTimer = setTimeout(() => {
          this.updateCarouselSwiper();
          this.scrollTimer = null;
        }, 500);
      }),
    );

    // 监听resize事件
    window.addEventListener(
      "resize",
      (this.resizeHandler = () => {
        // 节流
        if (this.resizeTimer) {
          return;
        }
        this.resizeTimer = setTimeout(() => {
          this.updateDomPointYs();
          this.updateCarouselSwiper();
          this.resizeTimer = null;
        }, 500);
      }),
    );
  }

  swiperDestroy() {
    if (this.scrollHandler !== null) {
      window.removeEventListener("scroll", this.scrollHandler);
      this.scrollHandler = null;
    }
    if (this.resizeHandler !== null) {
      window.removeEventListener("resize", this.resizeHandler);
      this.resizeHandler = null;
    }
  }

  /// 设置最接近视口中心的轮播控件轮播
  updateCarouselSwiper() {
    let autoPlaySwiper = this.findNearMidSwiper();
    if (autoPlaySwiper === this.currentAutoPlaySwiper) return;
    // 关闭其他轮播，只让最中心的轮播组件轮播
    this.refsDomList.forEach((item) => {
      this.$myrefs[item.ref].$refs.mySwiper.$swiper.autoplay.stop();
    });
    // console.log(this.$refs[this.refsDomList[minIndex].ref].$refs.mySwiper.$swiper)
    autoPlaySwiper.$refs.mySwiper.$swiper.autoplay.start();
    this.currentAutoPlaySwiper = autoPlaySwiper;
  }

  // 找到离屏幕中心点最近的轮播组件
  findNearMidSwiper() {
    // 计算浏览器视口中心点y值
    let innerMiddleY = window.visualViewport.pageTop + window.visualViewport.height / 2;

    // 找到离中心点最近的轮播控件
    let minIndex = 0;
    let minValue = Math.abs(this.refsDomList[0].domPointY - innerMiddleY);
    this.refsDomList.forEach((item, index) => {
      if (Math.abs(item.domPointY - innerMiddleY) < minValue) {
        minIndex = index;
        minValue = Math.abs(item.domPointY - innerMiddleY);
      }
    });
    return this.$myrefs[this.refsDomList[minIndex].ref];
  }

  /// 更新所有轮播控件的中心点坐标y值
  updateDomPointYs() {
    this.refsDomList.forEach((item) => {
      let refDom = this.$myrefs[item.ref].$el;
      item.domPointY = refDom.offsetTop + refDom.offsetHeight / 2;
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/swiper_controller.js